// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar__gdIPGGCdMtSR","avatar-withImage":"avatar-withImage__1D8NFjXL_Txw"};